import type { ClientChildResponse } from "./ClientChildResponse";
import type { ClientChildRequest } from "./ClientChildRequest";

export class ClientChildListItem {
  clientChildId: number;
  parentClientId: number;
  adultClientId: number | null;
  firstName: string;
  lastName: string;
  identityCode: string;
  isDeleted: boolean;
  birthDate: string;
  clientTypeLookupId: number | null;
  serviceLookupIds: number[];
  serviceLookupNames: string[];
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;

  constructor(response: ClientChildResponse) {
    this.clientChildId = response.clientChildId;
    this.parentClientId = response.parentClientId;
    this.adultClientId = response.adultClientId;
    this.firstName = response.firstName;
    this.lastName = response.lastName;
    this.identityCode = response.identityCode;
    this.isDeleted = response.isDeleted;
    this.birthDate = response.birthDate;
    this.clientTypeLookupId = response.clientTypeLookupId;
    this.serviceLookupIds = response.serviceLookupIds;
    this.serviceLookupNames = response.serviceLookupNames;
    this.createdDate = response.createdDate;
    this.createdBy = response.createdBy;
    this.modifiedDate = response.modifiedDate;
    this.modifiedBy = response.modifiedBy;
  }

  toRequest(): ClientChildRequest {
    return {
      parentClientId: this.parentClientId,
      firstName: this.firstName,
      lastName: this.lastName,
      identityCode: this.identityCode,
      birthDate: this.birthDate,
      clientTypeLookupId: this.clientTypeLookupId,
      serviceLookupIds: this.serviceLookupIds.length > 0 ? this.serviceLookupIds : null
    };
  }

  toResponse(): ClientChildResponse {
    return {
      clientChildId: this.clientChildId,
      parentClientId: this.parentClientId,
      adultClientId: this.adultClientId,
      firstName: this.firstName,
      lastName: this.lastName,
      identityCode: this.identityCode,
      isDeleted: this.isDeleted,
      birthDate: this.birthDate,
      clientTypeLookupId: this.clientTypeLookupId,
      serviceLookupIds: this.serviceLookupIds,
      serviceLookupNames: this.serviceLookupNames,
      createdDate: this.createdDate,
      createdBy: this.createdBy,
      modifiedDate: this.modifiedDate,
      modifiedBy: this.modifiedBy
    };
  }

  static createFromRequest(temporaryId: number, request: ClientChildRequest): ClientChildListItem {
    const timestamp = new Date().toISOString();
    return new ClientChildListItem({
      clientChildId: temporaryId,
      parentClientId: request.parentClientId,
      adultClientId: null,
      firstName: request.firstName,
      lastName: request.lastName,
      identityCode: request.identityCode,
      isDeleted: false,
      birthDate: request.birthDate,
      clientTypeLookupId: request.clientTypeLookupId,
      serviceLookupIds: request.serviceLookupIds || [],
      serviceLookupNames: [],
      createdDate: timestamp,
      createdBy: '',
      modifiedDate: timestamp,
      modifiedBy: ''
    });
  }
}
